/**
 * Entity types, mirroring the backend `entities.type` column and the
 * `activeMembership.entityType` claim. These are the keys of the profile
 * registry (see ADR FE-1); the individual persona is not an entity.
 */
export const ENTITY_TYPES = {
  STARTUP: 'startup',
  INVESTOR: 'investor',
  TRUSTED_PARTNER: 'trusted_partner',
} as const;

export type EntityType = (typeof ENTITY_TYPES)[keyof typeof ENTITY_TYPES];

/**
 * Entity-facing display label, shared by every screen that genericizes what
 * used to be startup-only copy (e.g. Team Access' "Manage your
 * {label} team" and its role chips "{label} Admin"/"{label} Member").
 */
export const ENTITY_LABEL: Record<EntityType, string> = {
  [ENTITY_TYPES.STARTUP]: 'Startup',
  [ENTITY_TYPES.INVESTOR]: 'Investor',
  [ENTITY_TYPES.TRUSTED_PARTNER]: 'Partner',
};
